import script from "./LanguageSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSelector.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageSelector.vue?vue&type=style&index=0&id=794a1145&lang=scss"

const __exports__ = script;

export default __exports__